export const fullPageViewHeightSkeletonProps = {
    height: '100vh',
    sx: {
        transform: 'none',
    },
};
